import * as RTooltip from "@radix-ui/react-tooltip";
import clsx from "clsx";
import { memo } from "react";

import classes from "./styles.module.scss";

import type { ITooltipProps } from "@/components/atoms/tooltip";
import { Typography } from "@/components/atoms/typography";

/**
 * Tooltip component that displays additional information on hover.
 *
 * @param {ITooltipProps} props - The props for the Tooltip component.
 * @param {string} props.text - The text content of the tooltip.
 * @param {string} [props.className] - Additional CSS class name for styling. Optional.
 * @param {ReactNode} props.children - The content that triggers the tooltip.
 * @returns Tooltip The rendered Tooltip component.
 */
export const Tooltip = memo(function Tooltip(props: ITooltipProps) {
  const { text, children, pos = "bottom", contentClassName } = props;

  return (
    <RTooltip.Root>
      <RTooltip.Trigger asChild>{children}</RTooltip.Trigger>
      <RTooltip.Portal>
        <RTooltip.Content
          className={clsx([classes.label, contentClassName])}
          side={pos || "bottom"}
          sideOffset={8}
        >
          <Typography
            color={"inherit"}
            createSpan
            fontSize={"xs"}
            fontWeight={"bold"}
          >
            {text}
          </Typography>
          <RTooltip.Arrow className={classes.triangle} />
        </RTooltip.Content>
      </RTooltip.Portal>
    </RTooltip.Root>
  );
});
